import { NgClass, NgStyle } from '@angular/common';
import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { AuthService } from 'src/app/core/authentication/auth.service';
import { SparrowIconEnum } from '../../core/icons-registry';

@Component({
  selector: 'sparrow-admin-header',
  templateUrl: './admin-header.component.html',
  styleUrls: ['./admin-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [RouterLink, MatIconModule, RouterLinkActive, MatMenuModule, NgStyle, NgClass],
})
export class AdminHeaderComponent implements OnInit {
  fullName: string;

  readonly SparrowIcon = SparrowIconEnum;

  constructor(private authService: AuthService) {}

  ngOnInit() {
    this.fullName = this.authService.userWithRoles.user.firstName + ' ' + this.authService.userWithRoles.user.lastName;
  }

  logout() {
    this.authService.logout();
  }
}
